import React from "react";
import {useFetch} from "../../../../src/hooks/useFetch";
import {useStore} from "../../../../src/hooks/useStore";
import {Skeleton, Select, Input, Table, Divider, message, DatePicker} from "antd";
import {CustomButton} from "../../../../src/components/_defaultComponents/CustomButton/CustomButton";
import {useEffect} from "react";
import {PlusOutlined, MinusOutlined} from "@ant-design/icons";
import moment from "moment";
import locale from "antd/es/date-picker/locale/tr_TR";

export const PoolPaymentContracts = ({poolId}) => {
    const stores = useStore();
    const [contracts, setContracts] = React.useState([]);
    const [description, setDescription] = React.useState("");
    const [isContractActiveEnabled, setIsContractActiveEnabled] = React.useState(true);
    const [contractId, setContractId] = React.useState(null);
    const [startDate, setStartDate] = React.useState(undefined);
    const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
    const [poolPaymentContractsLoading, poolPaymentContracts, _, __, refetch] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolStore.getPoolPaymentContracts.bind(null, {
            poolId
        })
    });

    useEffect(() => {
        const activeContractPrices = poolPaymentContracts?.data?.data?.filter(
            contract => contract?.endDate === null
        );

        setContracts(activeContractPrices);

        const initalDescription = poolPaymentContracts?.data?.data?.[0]?.description;
        setDescription(initalDescription);

        if (!contracts?.length && contracts?.some(contract => contract?.endDate !== null)) {
            setIsContractActiveEnabled(false);
        }

        const initalContractId = poolPaymentContracts?.data?.data?.[0]?.contractId;
        setContractId(initalContractId);
    }, [poolPaymentContracts]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isMobile = windowWidth < 900;

    const handleInputChange = (e, index, key) => {
        const newContracts = [...contracts];

        newContracts[index] = {
            ...newContracts[index],
            [key]: e.target.value
        };

        setContracts(newContracts);
    };

    const handleCreateContract = async () => {
        try {
            const values = {
                contractList: contracts.map(contract => {
                    return {
                        poolId,
                        feeType: contract.feeType,
                        clientAmount: contract.clientAmount,
                        courierAmount: contract.courierAmount,
                        minimumDistance: contract.minimumDistance,
                        description: description,
                        startDate: startDate
                            ? moment(startDate).format("YYYY-MM-DD")
                            : moment().format("YYYY-MM-DD")
                    };
                })
            };

            const result = await stores.poolStore.createPoolPaymentContract(values);

            if (result?.data?.success) {
                refetch();
            } else {
                message.error(result?.data?.message);
            }
        } catch (error) {
            message.error(error.message);
        } finally {
            setIsContractActiveEnabled(true);
        }
    };

    const contractContainerStyle = isMobile
        ? {flex: "1 1 320px", minWidth: 260, maxWidth: 500, width: "100%"}
        : {flex: 1, width: "100%"};

    if (poolPaymentContractsLoading) {
        return <Skeleton paragraph={{rows: 10, width: "100%"}} active={true}></Skeleton>;
    }

    return (
        <div style={{width: "100%"}}>
            <div
                style={{
                    background: "#fff",
                    borderRadius: 12,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                    padding: 32,
                    marginBottom: 32,
                    border: "1px solid #f0f0f0"
                }}
            >
                <h3
                    style={{
                        marginBottom: 24,
                        fontWeight: 700,
                        fontSize: 22,
                        borderBottom: "2px solid #e6e6e6",
                        paddingBottom: 12,
                        letterSpacing: 0.2
                    }}
                >
                    Güncel Sözleşme
                </h3>

                {contracts?.length ? (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 16,
                            marginBottom: 20
                        }}
                    >
                        <div style={{display: "flex", alignItems: "center", gap: 16}}>
                            <span
                                style={{
                                    fontWeight: 600,
                                    color: "#444"
                                }}
                            >
                                Sözleşme Id:
                            </span>
                            <span
                                style={{
                                    color: "#222",
                                    backgroundColor: "rgb(174, 2401,1, 0.5)",
                                    padding: 10,
                                    borderRadius: 10
                                }}
                            >
                                {contractId}
                            </span>
                        </div>
                        <div style={{display: "flex", alignItems: "center", gap: 16}}>
                            <span style={{fontWeight: 600, color: "#444"}}>Başlangıç Tarihi:</span>
                            {stores.meStore.checkRole("isCompanyUser") ? (
                                <Input
                                    style={{width: 250, marginLeft: 0, background: "#fafafa"}}
                                    value={moment(contracts?.[0]?.startDate).format("DD.MM.YYYY")}
                                    disabled
                                />
                            ) : (
                                <DatePicker
                                    locale={locale}
                                    value={
                                        startDate
                                            ? moment(startDate)
                                            : contracts?.[0]?.startDate
                                            ? moment(contracts?.[0]?.startDate)
                                            : moment()
                                    }
                                    format={"DD.MM.YYYY"}
                                    onSelect={date => setStartDate(date)}
                                    disabled={stores.meStore.checkRole("isCompanyUser")}
                                    style={{marginLeft: 0, background: "#fafafa"}}
                                    allowClear={false}
                                />
                            )}
                        </div>
                    </div>
                ) : null}

                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 16,
                        marginBottom: 20
                    }}
                >
                    <div style={contractContainerStyle}>
                        {contracts?.map((contract, index) => {
                            const contractRowStyle = isMobile
                                ? {
                                      flexDirection: "column",
                                      alignItems: "stretch",
                                      gap: 10,
                                      minWidth: 200,
                                      width: "100%"
                                  }
                                : {
                                      flexDirection: "row",
                                      alignItems: "center",
                                      gap: 10,
                                      minWidth: 260,
                                      width: "100%"
                                  };
                            const contractItemStyle = isMobile
                                ? {width: "100%", minWidth: 100, marginBottom: 8}
                                : {flex: "1 1 120px", minWidth: 120, maxWidth: 250};
                            return (
                                <div
                                    key={index.toString()}
                                    style={{
                                        marginBottom: 12,
                                        display: "flex",
                                        flexWrap: "wrap",
                                        background: "#fafbfc",
                                        borderRadius: 8,
                                        padding: "10px",
                                        boxSizing: "border-box",
                                        ...contractRowStyle
                                    }}
                                >
                                    {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                                        <div
                                            onClick={() => {
                                                setContracts(
                                                    contracts.filter((_, i) => i !== index)
                                                );
                                            }}
                                            style={{
                                                cursor: "pointer",
                                                color: "#b71c1c",
                                                fontSize: 18,
                                                marginRight: 4,
                                                backgroundColor: "#fff",
                                                border: "1.5px solid #d9d9d9",
                                                borderRadius: 8,
                                                padding: 8,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 30,
                                                height: 30,
                                                boxSizing: "border-box",
                                                boxShadow: "none",
                                                transition: "color 0.2s, border-color 0.2s"
                                            }}
                                            onMouseOver={e =>
                                                (e.currentTarget.style.color = "#e53935")
                                            }
                                            onMouseOut={e =>
                                                (e.currentTarget.style.color = "#b71c1c")
                                            }
                                        >
                                            <MinusOutlined />
                                        </div>
                                    )}
                                    <div style={{...contractItemStyle, maxWidth: 215}}>
                                        <h5>Ücret Tipi*</h5>
                                        <Select
                                            disabled={
                                                !stores.meStore.checkRole(
                                                    "notVisibleForCompanyUser"
                                                ) && isContractActiveEnabled
                                            }
                                            defaultValue={contract?.feeType}
                                            style={{
                                                width: "100%",
                                                minWidth: 100,
                                                maxWidth: 215,
                                                marginRight: 10
                                            }}
                                            options={[
                                                {
                                                    value: "PAKET",
                                                    label: "PAKET"
                                                },
                                                {
                                                    value: "KM",
                                                    label: "MESAFE"
                                                },
                                                {
                                                    value: "SAATLIK_UCRET",
                                                    label: "SAATLİK ÜCRET"
                                                },
                                                {
                                                    value: "SAATLIK_GARANTI_UCRET",
                                                    label: "SAATLİK GARANTİ ÜCRET"
                                                }
                                            ]}
                                            value={contract?.feeType}
                                            onChange={value => {
                                                handleInputChange(
                                                    {
                                                        target: {
                                                            value
                                                        }
                                                    },
                                                    index,
                                                    "feeType"
                                                );
                                            }}
                                        />
                                    </div>
                                    <div style={{...contractItemStyle}}>
                                        <h5>
                                            {stores.meStore.checkRole("notVisibleForCompanyUser")
                                                ? "Müşteri Fiyatı"
                                                : "Fiyat"}
                                        </h5>
                                        <Input
                                            disabled={
                                                !stores.meStore.checkRole(
                                                    "notVisibleForCompanyUser"
                                                ) && isContractActiveEnabled
                                            }
                                            value={contract?.clientAmount}
                                            style={{
                                                width: "100%",
                                                minWidth: 100,
                                                maxWidth: 250,
                                                marginRight: 10
                                            }}
                                            onChange={e =>
                                                handleInputChange(e, index, "clientAmount")
                                            }
                                        />
                                    </div>
                                    <div style={{...contractItemStyle}}>
                                        <h5>Kurye Fiyatı</h5>
                                        {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                                            <Input
                                                disabled={isContractActiveEnabled}
                                                value={contract?.courierAmount}
                                                style={{
                                                    width: "100%",
                                                    minWidth: 100,
                                                    maxWidth: 250
                                                }}
                                                onChange={e =>
                                                    handleInputChange(e, index, "courierAmount")
                                                }
                                            />
                                        )}
                                    </div>
                                    <div style={{...contractItemStyle}}>
                                        <h5>Minimum Mesafe</h5>
                                        <Input
                                            disabled={
                                                contract?.feeType !== "KM"
                                                    ? true
                                                    : isContractActiveEnabled
                                            }
                                            value={
                                                contract?.feeType === "KM"
                                                    ? contract?.minimumDistance
                                                    : ""
                                            }
                                            style={{width: "100%", minWidth: 100, maxWidth: 250}}
                                            onChange={e =>
                                                handleInputChange(e, index, "minimumDistance")
                                            }
                                        />
                                    </div>
                                </div>
                            );
                        })}
                        {stores.meStore.checkRole("notVisibleForCompanyUser") &&
                        contracts?.length < 4 ? (
                            <div
                                onClick={() => {
                                    setContracts([...contracts, {}]);
                                    setIsContractActiveEnabled(false);
                                }}
                                style={{
                                    cursor: "pointer",
                                    color: "#388e3c",
                                    fontSize: 20,
                                    marginLeft: 4,
                                    marginTop: 2,
                                    backgroundColor: "#fff",
                                    border: "1.5px solid #d9d9d9",
                                    borderRadius: 8,
                                    padding: 8,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 30,
                                    height: 30,
                                    boxSizing: "border-box",
                                    boxShadow: "none",
                                    transition: "color 0.2s, border-color 0.2s"
                                }}
                                onMouseOver={e => (e.currentTarget.style.color = "#43a047")}
                                onMouseOut={e => (e.currentTarget.style.color = "#388e3c")}
                            >
                                <PlusOutlined />
                            </div>
                        ) : null}
                    </div>
                    {contracts?.length ? (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "center",
                                marginLeft: 32,
                                marginTop: 0
                            }}
                        >
                            <CustomButton
                                onClick={
                                    isContractActiveEnabled
                                        ? () => {
                                              setIsContractActiveEnabled(false);
                                          }
                                        : () => {
                                              handleCreateContract();
                                          }
                                }
                                style={{
                                    minWidth: 120,
                                    fontWeight: 600,
                                    fontSize: 16,
                                    height: 40,
                                    borderRadius: 8
                                }}
                            >
                                {stores.meStore.checkRole("notVisibleForCompanyUser") &&
                                    (isContractActiveEnabled ? "Aktif Et" : "Kaydet")}
                            </CustomButton>
                        </div>
                    ) : null}
                </div>
                {contracts?.length ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            marginTop: 24,
                            alignItems: "center"
                        }}
                    >
                        <span style={{fontWeight: 600, color: "#444"}}>Ekstra Not:</span>
                        <Input
                            style={{
                                width: 350,
                                marginLeft: 12,
                                background: "#fafafa",
                                borderRadius: 6
                            }}
                            value={description}
                            onChange={e => setDescription(e.target.value)}
                            disabled={isContractActiveEnabled}
                        />
                    </div>
                ) : null}
                <div style={{color: "#888", marginTop: 10, fontSize: 13, fontStyle: "italic"}}>
                    her şey kdv hariç
                </div>
            </div>

            <Divider style={{marginTop: 20, marginBottom: 20}} />

            <h3 style={{marginTop: 10, marginBottom: 10}}>Ödeme Sözleşmeleri</h3>
            <Table dataSource={poolPaymentContracts?.data?.data}>
                <Table.Column title="Sözleşme Id" dataIndex="contractId" />
                <Table.Column
                    title="Başlangıç Tarihi"
                    dataIndex="startDate"
                    render={date => moment(date).format("DD.MM.YYYY")}
                />
                <Table.Column
                    title="Bitiş Tarihi"
                    dataIndex="endDate"
                    render={date => (date ? moment(date).format("DD.MM.YYYY") : "Aktif")}
                />
                <Table.Column title="Ücret Tipi" dataIndex="feeType" />
                {stores.meStore.checkRole("notVisibleForCompanyUser") ? (
                    <Table.Column
                        title="Müşteri Fiyatı"
                        dataIndex="clientAmount"
                        render={amount => amount + " TL"}
                    />
                ) : (
                    <Table.Column
                        title="Fiyat"
                        dataIndex="clientAmount"
                        render={amount => amount + " TL"}
                    />
                )}
                {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                    <Table.Column
                        title="Kurye Fiyatı"
                        dataIndex="courierAmount"
                        render={amount => amount + " TL"}
                    />
                )}
                {
                    <Table.Column
                        title="Minimum Mesafe"
                        dataIndex="minimumDistance"
                        render={distance => distance !== 0 && distance + " KM"}
                    />
                }
                <Table.Column title="Ekstra Not" dataIndex="description" />
            </Table>
        </div>
    );
};

export default PoolPaymentContracts;
